import React from 'react';

function ChevronRightIcon(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="10"
            fill="none"
            viewBox="0 0 6 10"
            {...props}
        >
            <path
                fill="#BEBEBE"
                fillRule="evenodd"
                d="M5.808 4.55L1.136.18a.71.71 0 00-.944 0 .604.604 0 000 .883L4.4 5 .192 8.937a.604.604 0 000 .883.71.71 0 00.944 0l4.672-4.386a.604.604 0 000-.883z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

export default ChevronRightIcon;
